export const LAYOUT_COMMON_USER_ROOT = '/app/common/user'
export const LAYOUT_COMMON_USER_CHANGE_PASSWORD = '/app/common/user/change-password'

export const LAYOUT_COMMON_ERROR_ROOT = '/app/error'

export const LAYOUT_COMMON_ERROR_403 = '/app/error/403'
export const LAYOUT_COMMON_ERROR_404 = '/app/error/404'
export const LAYOUT_COMMON_ERROR_500 = '/app/error/500'
export const LAYOUT_COMMON_ERROR_UNKNOWN = '/app/error/unknown'
